// extracted by mini-css-extract-plugin
module.exports = {"canvas":"graph_canvas__3g5Ls","canvasBackground":"graph_canvasBackground__3Ci2S","pointui":"graph_pointui__3Ee-0"};